var map = {
	"./anaheim.svg": "3831",
	"./arizona.svg": "85fd",
	"./boston.svg": "34f0",
	"./buffalo.svg": "795e",
	"./calgary.svg": "5b6a",
	"./carolina.svg": "4910",
	"./chicago.svg": "e2fa",
	"./colorado.svg": "ce0f",
	"./columbus.svg": "7eff",
	"./dallas.svg": "ba21",
	"./detroit.svg": "a3e1",
	"./edmonton.svg": "a363",
	"./florida.svg": "2cf49",
	"./los-angeles.svg": "528a",
	"./minnesota.svg": "822c",
	"./montreal.svg": "e499",
	"./nashville.svg": "f68b",
	"./new-jersey.svg": "bd87",
	"./new-york-islanders.svg": "fe6e",
	"./new-york-rangers.svg": "eb86",
	"./ottawa.svg": "d9bb",
	"./philadelphia.svg": "6478",
	"./pittsburgh.svg": "7a1c",
	"./san-jose.svg": "9416",
	"./seattle.svg": "d28c",
	"./st-louis.svg": "a5ee",
	"./tampa-bay.svg": "179b",
	"./toronto.svg": "e090",
	"./vancouver.svg": "7b5c",
	"./washington.svg": "01c9",
	"./winnipeg.svg": "21f6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9635";